module.exports = __webpack_public_path__ + "static/media/earth.c849ea5e.jpg";